var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notData"},[_c('img',{attrs:{"src":"/images/nothing.png?x-oss-process=image/resize,m_lfit,h_200,w_200&d=200x200","alt":""}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('noData')))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b4a8710","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/notData.vue
// module id = UOyh
// module chunks = 25 28 29 31 32 33 34 41